// extracted by mini-css-extract-plugin
export default {"name":"styles_name__tqY10","name_empty":"styles_name_empty__3Ffdi"};